// extracted by mini-css-extract-plugin
module.exports = {"Container":"App_Container__2-xoM","MainProduct":"App_MainProduct__3o9NP","ProductInfo":"App_ProductInfo__3zKYt"};